import $ from "jquery";
import { Splide } from "@splidejs/splide";

const slider = () => {
    if ($(".js-slider").length) {
        $(".js-slider").not(".is-initialized").each(function (index, sliderElement) {
            var config = {
                type: "loop",
                pagination: false,
                arrows: true,
            };
            var slider = new Splide(sliderElement, config);

            slider.mount();
        });
    }
};

export default slider;
